export default "__VITE_ASSET__DWS6sY9z__"